import { useEffect, useState } from "react"
import HeaderTarifs from "./HeaderTarifs"
import RatePlanGrid from "./RatePlanGrid/RatePlanGrid"
import RatePlansDrawer from "./RatePlansDrawer"
import axios from "axios"
import { useParams } from "react-router-dom"
import { Stack, Container } from "@mantine/core";

const TarifsPage = ({ needRatePlanMsg, setNeedRatePlanMsg, setActivePage }) => {
  const hotelParams = useParams();
  const hotelId = hotelParams.hotelId;

  const [rooms, setRooms] = useState([])
  const [ratePlans, setRatePlans] = useState([])
  const [showDrawer, setShowDrawer] = useState(false)
  const [editingRatePlan, setEditingRatePlan] = useState(null)

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/rooms/hotel/${hotelId}` // ✅
        )
        setRooms(res.data)
      } catch (err) {
        console.error(err)
      }
    }
    fetchRooms()
  }, [])

  useEffect(() => {
    const fetchRatePlan = async () => {
      try {
        const res = await axios.get(
          `https://api.komorotel.com/api/rateplans/hotel/${hotelId}` // ✅
        )
        setRatePlans(res.data)
      } catch (err) {
        console.error(err)
      }
    }
    fetchRatePlan()
  }, [])

  const openDrawer = () => setShowDrawer(true)

  const closeDrawer = () => {
    setShowDrawer(false)
    setEditingRatePlan(null)
  }

  const handleCreateRatePlan = async (newRatePlan) => {
  try {
    const res = await axios.post(
      "https://api.komorotel.com/api/rateplans",
      newRatePlan,
      { withCredentials: true }
    );
    setRatePlans((prev) => [...prev, res.data]);
    
    // ✅ Rediriger vers le calendrier après création
    setActivePage("inventory");

  } catch (err) {
    console.error(err);
  }
};

  const handleDeleteRatePlan = async (ratePlan) => {
    try {
      await axios.delete(
        `https://api.komorotel.com/api/rateplans/${ratePlan._id}`, // ✅
        { withCredentials: true }
      )
      setRatePlans((prev) => prev.filter((rp) => rp._id !== ratePlan._id))
    } catch (err) {
      console.error(err)
    }
  }

  const handleUpdateRatePlan = async (ratePlanId, newRatePlan) => {
    try {
      const res = await axios.put(
        `https://api.komorotel.com/api/rateplans/${ratePlanId}`, // ✅
        newRatePlan,
        { withCredentials: true }
      )
      setRatePlans((prev) =>
        prev.map((plan) =>
          plan._id.toString() === ratePlanId.toString() ? res.data : plan
        )
      )
    } catch (err) {
      console.error(err)
    }
  }

  const handleEdit = (plan) => {
    setEditingRatePlan(plan)
    setShowDrawer(true)
  }

  return (
    <Container size="lg" py="xl">
      <Stack gap="xl">

        {/* ✅ Banner message si vient de availability */}
        {needRatePlanMsg && (
          <div className="flex items-start gap-3 px-4 py-3 bg-amber-50 border border-amber-200 rounded-xl">
            <span className="text-amber-500 text-lg shrink-0">⚡</span>
            <div className="flex-1">
              <p className="text-sm font-semibold text-amber-800">
                Disponibilité configurée !
              </p>
              <p className="text-xs text-amber-600 mt-0.5">
                Créez maintenant un tarif pour rendre votre chambre réservable.
              </p>
            </div>
            <button
              onClick={() => setNeedRatePlanMsg(false)}
              className="text-amber-400 hover:text-amber-600 text-lg leading-none"
            >
              ×
            </button>
          </div>
        )}

        <HeaderTarifs openDrawer={openDrawer} />

        <RatePlanGrid
          ratePlans={ratePlans}
          handleEdit={handleEdit}
          handleDelete={handleDeleteRatePlan}
        />

      </Stack>

      <RatePlansDrawer
        show={showDrawer}
        onHide={closeDrawer}
        rooms={rooms}
        onCreate={handleCreateRatePlan}
        onUpdate={handleUpdateRatePlan}
        hotelId={hotelId}
        editingPlan={editingRatePlan}
      />

    </Container>
  )
}

export default TarifsPage